import {
  Box,
  BoxProps,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import NotFoundCover from 'images/people.svg';
import fp from 'lodash/fp';
import { nanoid } from 'nanoid';
import { useTranslation } from 'react-i18next';
import { IReferenceResource } from 'services/resources/users/reference/types.d';
import { IUserResource } from 'services/resources/users/user/types.d';

import {
  getEmail,
  getFirstSurname,
  getId,
  getLastSurname,
  getName,
  getReferences,
} from '../helpers/data-helpers';
import { EmptyBanner } from './EmptyBanner';

export interface IReferencesProps extends BoxProps {
  /**
   * User resource data.
   */
  user?: IUserResource;
}

export const References: React.FC<IReferencesProps> = (props): JSX.Element => {
  const { user, ...rest } = props;

  const { t } = useTranslation('kyc-physical');

  if (fp.isEmpty(getReferences(user))) {
    return (
      <EmptyBanner
        cover={NotFoundCover}
        mb={6}
        title={t('page.detail.references.empty.title')}
      />
    );
  }

  return (
    <Box {...rest}>
      <Table colorScheme="blackAlpha" variant="striped">
        <Thead>
          <Tr>
            <Th>{t('page.detail.table.title.id')}</Th>
            <Th>{t('page.detail.table.title.name')}</Th>
            <Th>{t('page.detail.table.title.first-surname')}</Th>
            <Th>{t('page.detail.table.title.last-surname')}</Th>
            <Th>{t('page.detail.table.title.email')}</Th>
          </Tr>
        </Thead>
        <Tbody>
          {getReferences(user)?.map((item: IReferenceResource) => (
            <Tr key={nanoid()}>
              <Td>{getId(item)}</Td>
              <Td>{getName(item)}</Td>
              <Td>{getFirstSurname(item)}</Td>
              <Td>{getLastSurname(item)}</Td>
              <Td>{getEmail(item)}</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};

References.defaultProps = {
  overflow: 'scroll',
};
